import axios from "axios";
import { removeLoginCookie } from "components/LoginForm/LoginFormDao";
import { toastrError } from "lib/toastr";

const url = window.location.href;

let baseURL: string;

if (url.includes("localhost")) {
  baseURL = "http://localhost:3001";
} else if (url.includes("zampliasurveys")) {
  baseURL = "https://zampliasurveysbackend-development.azurewebsites.net";
} else {
  baseURL = "https://zampliasurveysbackend-sandbox.azurewebsites.net";
}

/**
 * Resolved backend origin. Exported because the ALTCHA widget fetches its
 * challenge directly rather than through axios, so it needs an absolute URL.
 */
export const apiBaseUrl = baseURL;

export const axiosClient = axios.create({
  baseURL,
  withCredentials: true,
});

// Add JWT Token to Requests
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 Unauthorized Errors
let isSessionExpired = false;

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (!isSessionExpired) {
        isSessionExpired = true;
        toastrError("Session expired or logged in from another device");
        localStorage.removeItem("access_token");
        removeLoginCookie("setLoginCookie");
        localStorage.removeItem('bonusPopup');
        localStorage.removeItem("joinQualPopup");
        localStorage.removeItem('auth_ls');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);